export default {
  strict: true,
  namespaced: true,
  state: {
    redirect: "/",
  },
  getters: {
    redirect: state => state.redirect,
  },
  mutations: {
    setRedirect: (state, payload) => (state.redirect = payload),
  },
  actions: {
    setRedirect: (context, payload) => context.commit("setRedirect", payload),
  },
};
